import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Mail, Send } from "lucide-react";

export default function Digest() {
  const [data, setData] = useState(null);

  const load = async () => setData((await api.get("/digest/weekly")).data);
  useEffect(() => { load(); }, []);

  const send = async () => {
    const r = await api.post("/digest/weekly/send");
    toast.success(`Queued to ${r.data.sent_to.length} founder${r.data.sent_to.length === 1 ? "" : "s"}`);
  };

  if (!data) return <div className="text-sm text-[#71717A]">Loading…</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight flex items-center gap-2"><Mail size={20} /> Weekly digest</h1>
          <p className="text-sm text-[#A1A1AA] mt-1">{data.week_start} → {data.week_end}</p>
        </div>
        <button onClick={send} className="tt-btn-primary flex items-center gap-2"><Send size={14} /> Email to founders</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Section title="Leaves">
          <R k="This week" v={data.leaves.this_week} />
          <R k="Last week" v={data.leaves.last_week} />
          <R k="Pending approval" v={data.leaves.pending} accent={data.leaves.pending > 0 ? "warn" : "neutral"} />
        </Section>
        <Section title="Tickets">
          <R k="Overdue" v={data.overdue_tickets} accent={data.overdue_tickets > 0 ? "warn" : "neutral"} />
        </Section>
        <Section title="Hiring">
          <R k="Forms live" v={data.hiring.forms_live} />
          <R k="New applicants" v={data.hiring.new_applicants} />
          <R k="Interviews booked" v={data.hiring.interviews_booked} />
          <R k="Offers out" v={data.hiring.offers_out} />
        </Section>
        <Section title="Training">
          <R k="Stuck" v={data.training.stuck} accent={data.training.stuck > 0 ? "warn" : "neutral"} />
          <R k="Ready this week" v={data.training.ready_this_week} accent="pass" />
        </Section>
        <Section title="Praise vs issues">
          <R k="Praise" v={data.praise_vs_issues.praise} accent="pass" />
          <R k="Issues" v={data.praise_vs_issues.issues} accent="warn" />
        </Section>
        <Section title="Upcoming">
          <div className="tt-label mt-2 mb-1">Probation ending</div>
          {data.upcoming.probation_ends.length === 0 && <div className="text-sm text-[#71717A]">—</div>}
          {data.upcoming.probation_ends.map((p) => <div key={p.employee_id} className="text-sm">{p.display_name || p.legal_name} <span className="font-mono text-xs text-[#71717A]">· {p.probation_end}</span></div>)}
          <div className="tt-label mt-3 mb-1">Anniversaries</div>
          {data.upcoming.anniversaries.length === 0 && <div className="text-sm text-[#71717A]">—</div>}
          {data.upcoming.anniversaries.map((a) => <div key={a.employee_id} className="text-sm">{a.name} <span className="font-mono text-xs text-[#71717A]">· {a.date}</span></div>)}
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return <div className="tt-card p-5"><div className="tt-label mb-3">{title}</div><div className="space-y-1">{children}</div></div>;
}
function R({ k, v, accent }) {
  const c = accent === "warn" ? "text-[#F5A524]" : accent === "pass" ? "text-[#22C55E]" : "text-[#F4F4F5]";
  return <div className="flex items-center justify-between py-1 border-b border-[#1E1E1E] last:border-0"><span className="text-[#A1A1AA]">{k}</span><span className={`font-mono ${c}`}>{v}</span></div>;
}
